import ConversationPracticeView from "@features/tools/view/spoken-dialogue-view/conversation-practice-view";

const ConversationPractice = () => {
  return <ConversationPracticeView />;
};

export default ConversationPractice;
